import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import Icon from 'react-native-vector-icons/Feather';
import { Colors, Radius, Typography } from '../../theme';

interface Props {
  senderName: string;
  text: string;
  /** Pass to render the dismissible compose-bar variant (above the input). Omit for the read-only in-bubble quote. */
  onDismiss?: () => void;
  tint?: 'me' | 'them';
}

/** Compact quoted-message card — used above the input while composing a reply, and inside a bubble that has `replyTo`. */
const ReplyPreview: React.FC<Props> = ({ senderName, text, onDismiss, tint = 'them' }) => (
  <View style={[styles.card, tint === 'me' ? styles.cardMe : styles.cardThem]}>
    <View style={styles.accentBar} />
    <View style={styles.textBlock}>
      <Text style={styles.senderName} numberOfLines={1}>{senderName}</Text>
      <Text style={styles.text} numberOfLines={1}>{text || 'Photo'}</Text>
    </View>
    {onDismiss ? (
      <TouchableOpacity onPress={onDismiss} hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}>
        <Icon name="x" size={14} color="rgba(255,255,255,0.6)" />
      </TouchableOpacity>
    ) : null}
  </View>
);

export default ReplyPreview;

const styles = StyleSheet.create({
  card: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    borderRadius: Radius.md,
    paddingVertical: 6,
    paddingHorizontal: 8,
    marginBottom: 4,
    overflow: 'hidden',
  },
  cardThem: {
    backgroundColor: 'rgba(255,255,255,0.07)',
  },
  cardMe: {
    backgroundColor: 'rgba(0,0,0,0.16)',
  },
  accentBar: {
    width: 3,
    alignSelf: 'stretch',
    borderRadius: 2,
    backgroundColor: Colors.turquoise,
  },
  textBlock: {
    flex: 1,
    minWidth: 0,
  },
  senderName: {
    color: Colors.turquoise,
    fontSize: 11,
    fontWeight: Typography.bold,
  },
  text: {
    color: 'rgba(255,255,255,0.68)',
    fontSize: 12,
    marginTop: 1,
  },
});
